import { Button, Flex, Text } from "@chakra-ui/react"
import { useIsNewVersionAvailable } from "hook/newVersion"
import { useState } from "react"

// Плашка «вышла новая версия» (KRE-773), как в Axios CRM.
// Справа внизу, но выше полосы с кнопками проверки (StickyBottomBar) — чтобы
// не закрывать «Отправить». Закрыть нельзя намеренно: иначе предупреждение
// пропадёт до перезагрузки, и человек так и останется на старом коде
export const UpdateBanner = () => {
  const isNewVersionAvailable = useIsNewVersionAvailable()
  // Перезагрузка занимает секунду-две: без блокировки кнопку жмут второй раз
  // и решают, что она не работает
  const [isReloading, setIsReloading] = useState(false)

  if (!isNewVersionAvailable) {
    return null
  }

  const handleReload = () => {
    setIsReloading(true)
    window.location.reload()
  }

  return (
    <Flex
      position="fixed"
      // На узком экране — во всю ширину, иначе плашка уезжает за левый край
      left={{ base: 4, sm: "auto" }}
      right={{ base: 4, sm: 6 }}
      bottom={24}
      zIndex="banner"
      maxW="sm"
      direction="column"
      alignItems="flex-start"
      gap={3}
      p={4}
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="lg"
      boxShadow="lg"
      role="status"
      aria-live="polite"
    >
      <Text fontSize="sm">
        Вышла новая версия сайта. Чтобы не было ошибок, перезагрузите страницу.
      </Text>
      <Button
        size="sm"
        colorScheme="blue"
        isLoading={isReloading}
        loadingText="Перезагружаем"
        onClick={handleReload}
      >
        Перезагрузить
      </Button>
    </Flex>
  )
}
